import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=700735d9"
import script from "./MainMenu.js?vue&type=script&lang=js&external"
export * from "./MainMenu.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports